/* eslint-disable ordered-imports/ordered-imports */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { FC } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";
import { CoveoProductContextModel } from "@NA/Components/Coveo/Contexts/CoveoProductContext";
// import { sendClickEvent } from "@NA/Services/ADICoveoService";

interface OwnProps {
    product: CoveoProductContextModel;
    extendedStyles?: ProductImageStyles;
    sourceName?: string;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state)?.pathname;
    return {
        location,
    };
};

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            min-height: auto;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto !important;
            width: 100% !important;
        `,
    },
};

const CoveoProductImage: FC<Props> = ({ location, product, extendedStyles, sourceName }) => {
    const [styles] = React.useState(() => mergeToNew(productImageStyles, extendedStyles));

    let altText = product.coveoProduct.imageAltText;
    if (!altText || altText === "") {
        altText = product.coveoProduct.title;
    }

    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";

    const imagePath = product.coveoProduct.mediumImagePath || product.coveoProduct.smallImagePath;

    const productCatalogUrl = product.coveoProduct.canonicalUrl;

    const clickHandler = () => {
        sessionStorage.setItem("item_list_name", sourceName ?? "");
        // sendClickEvent(product.coveoProduct);
        product.coveoProduct.interactiveProduct?.select()
    };
    return (
        <Clickable {...styles.linkWrappingImage} href={productCatalogUrl} data-test-selector="productImage" onClick={clickHandler}>
            <Img {...styles.img} loading={loading} src={imagePath} altText={altText} />
        </Clickable>
    );
};

export default connect(mapStateToProps)(CoveoProductImage);
